export { default } from './Rating'
